import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=08cb4516&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=js&"
export * from "./ModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=08cb4516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb4516",
  null
  
)

export default component.exports